export const authReducer = (state, action) => {
    var _a, _b;
    switch (action.type) {
        case 'AUTH_RETRY': {
            return Object.assign({}, state, {
                status: 'undetermined',
                userData: null,
                refreshing: false,
            });
        }
        case 'AUTH_LOADING': {
            return Object.assign({}, state, {
                status: 'loading',
                userData: null,
                refreshing: false,
            });
        }
        case 'AUTH_SUCCESS': {
            return Object.assign({}, state, {
                status: 'authenticated',
                userData: action.payload,
                refreshing: false,
            });
        }
        case 'AUTH_REFRESH': {
            return Object.assign({}, state, {
                status: 'authenticated',
                userData: state.userData,
                refreshing: true,
            });
        }
        case 'AUTH_UPDATE': {
            return Object.assign({}, state, {
                status: 'authenticated',
                userData: Object.assign(Object.assign({}, state.userData), { naam: action.payload }),
                refreshing: false,
            });
        }
        case 'AUTH_FAILED':
        case 'LOGOUT': {
            if ((_a = state.userData) === null || _a === void 0 ? void 0 : _a.unauthenticatedUri) {
                window.location.href = ((_b = state.userData) === null || _b === void 0 ? void 0 : _b.unauthenticatedUri) + 'Uitloggen';
                return Object.assign({}, state, {
                    status: 'loading',
                    userData: null,
                    refreshing: false,
                });
            }
            return Object.assign({}, state, {
                status: 'unauthenticated',
                userData: null,
                refreshing: false,
            });
        }
        default:
            throw new Error('Unexpected Action');
    }
};
